import {
  Directive,
  ElementRef,
  HostBinding,
  HostListener,
  Input,
  OnInit,
} from "@angular/core";

@Directive({ selector: "input[focusBlur]" })
export class inputFocusBlur implements OnInit {
  @HostBinding("class.floatPlaceholder-active") floatPlaceholderActiveClass =
    false;

  @HostListener("blur", ["$event"])
  onBlur(event) {
    event.target.value.toString().length
      ? (this.floatPlaceholderActiveClass = true)
      : (this.floatPlaceholderActiveClass = false);
  }

  @HostListener("focus", ["$event"])
  onFocus() {
    this.floatPlaceholderActiveClass = true;
  }

  constructor(private el: ElementRef) {}

  ngOnInit() {
    this.floatPlaceholderActiveClass = Boolean(this.el.nativeElement.value);
  }
}
